module.exports = __webpack_public_path__ + "img/4.1d1607a7.png";